import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const AuthContainer = ({ children, title, subTitle }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: { xs: "auto", sm: "70vh" },
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "28px",
          width: "360px",
          padding: "32px",
          height: { xs: "100vh", sm: "auto" },
        }}
      >
        <h2 style={{ fontSize: "36px", marginBottom: "12px", marginTop: 0 }}>
          {title}
        </h2>
        <Typography sx={{ mb: 2 }}>{subTitle}</Typography>
        {children}
      </Box>
    </Box>
  );
};

export default AuthContainer;
